document.addEventListener('change',event=>{
  if(!event.target.matches('[data-variant-select]')) return;
  const option=event.target.selectedOptions[0];
  const root=event.target.closest('.product-copy');
  const price=root?.querySelector('[data-product-price]');
  const submit=root?.querySelector('button[name="add"]');
  if(price && option) price.textContent=option.dataset.price;
  if(submit && option){submit.disabled=option.disabled;submit.textContent=option.disabled?'Unavailable':'Add to bag';}
  const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState(null,'',url);
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.mobile-nav[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});

// Progressive enhancement: page content remains readable without JavaScript.
function addReadingGuide(scope=document){
  scope.querySelectorAll('[data-reading-guide]').forEach(article=>{
    if(article.dataset.guideReady) return;
    const headings=[...article.querySelectorAll('h2')];
    if(headings.length<3) return;
    article.dataset.guideReady='true';
    const nav=document.createElement('nav');
    nav.className='reading-guide';nav.setAttribute('aria-label','On this page');
    const label=document.createElement('p');label.textContent='On this page';
    const list=document.createElement('ol');
    headings.forEach((heading,index)=>{
      if(!heading.id){
        let id='reading-section-'+(index+1);
        while(document.getElementById(id)) id+='-next';
        heading.id=id;
      }
      const item=document.createElement('li');const link=document.createElement('a');
      link.href='#'+encodeURIComponent(heading.id);link.textContent=heading.textContent;
      link.addEventListener('click',()=>{heading.tabIndex=-1;heading.focus({preventScroll:true});});
      item.append(link);list.append(item);
    });
    nav.append(label,list);article.before(nav);
  });
}
addReadingGuide();
document.addEventListener('shopify:section:load',event=>addReadingGuide(event.target));
document.addEventListener('click',event=>{
  document.querySelectorAll('.mobile-nav[open]').forEach(menu=>{
    if(!menu.contains(event.target)||event.target.closest('nav a')) menu.open=false;
  });
});

// Native dialog keeps keyboard focus inside the enlarged image.
document.addEventListener('click', event => {
  const link = event.target.closest('[data-image-zoom]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const dialog = document.querySelector('[data-image-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  event.preventDefault();
  const image = dialog.querySelector('img');
  let status = dialog.querySelector('[data-image-status]');
  if (!status) {
    status = document.createElement('p');
    status.setAttribute('data-image-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    image.before(status);
  }
  status.hidden = false;
  status.textContent = 'Loading photograph…';
  image.hidden = true;
  image.onload = () => { image.hidden = false; status.hidden = true; };
  image.onerror = () => {
    status.hidden = false;
    status.textContent = 'This photograph could not be loaded. Close this view and try again.';
  };
  image.src = link.href;
  image.alt = link.querySelector('img')?.alt || 'Product photograph';
  dialog.showModal();
  dialog.addEventListener('close', () => link.focus(), {once: true});
});
document.addEventListener('click', event => {
  if (event.target.closest('[data-close-image]')) {
    event.target.closest('dialog').close();
  }
});
// The image dialog has one interactive control; keep both Tab directions on it.
document.addEventListener('keydown', event => {
  const dialog = event.target.closest('[data-image-dialog]');
  if (event.key === 'Tab' && dialog?.open) {
    event.preventDefault();
    dialog.querySelector('[data-close-image]').focus();
  }
});
